module.exports = __webpack_public_path__ + "static/media/Avenir-Medium-01.42f3c719.svg";